import { render, staticRenderFns } from "./deleteButton.vue?vue&type=template&id=2e5910e8&"
import script from "./deleteButton.vue?vue&type=script&lang=js&"
export * from "./deleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports